import { Popconfirm } from "antd";
import AppButton from "../AppButton";


const ConfirmDeleteButton = ({ title, onConfirm, okText, cancelText, ...props }) => {
  return (
    <Popconfirm
      title={title}
      onConfirm={onConfirm}
      okText={okText ?? "Yes"}
      cancelText={cancelText ?? "No"}
    >
      <span>
        <AppButton variant="delete" {...props}>
          Delete
        </AppButton>
      </span>
    </Popconfirm>
  );
};

export default ConfirmDeleteButton;
